











































import { addDays, anyToDate, formatDate, isFuture, isToday } from 'vtils/date'
import {
  apiCommodityWriteOffCommoditySkuDetail,
  ApiCommodityWriteOffCommoditySkuDetailResponse,
  apiTradeGeneralTradePreOrder,
  ApiTradeGeneralTradePreOrderRequest,
} from '@/api'
import { currentSaleChannelId } from '@/channel'
import { defineClassComponent } from '@/hooks'
import { jointGoodsModelProvider } from '../model'
import { keyBy, orderBy } from 'vtils'
import { navigateTo } from '@/router'
import { nextTick, ref } from '@vue/composition-api'
import { requiredDeep, submit, Track } from '@/utils'

export default defineClassComponent(
  () =>
    class {
      jointGoodsModel = jointGoodsModelProvider.inject()

      showDatePicker = ref(false)

      initialDate = ref<Date>()

      minDate = ref(new Date())

      maxDate = ref(addDays(new Date(), 40))

      skuData =
        ref<
          Record<string, ApiCommodityWriteOffCommoditySkuDetailResponse[0]>
        >()

      formatDate = (day: {
        date: Date
        topInfo?: string
        text: string | number
        bottomInfo?: string
        type: 'disabled' | 'selected' | ''
      }) => {
        if (day.type !== 'disabled') {
          const skuInfo =
            this.skuData.value![formatDate(day.date, 'yyyy-mm-dd')]
          if (!skuInfo || skuInfo.surplusStock === 0) {
            day.type = 'disabled'
          }
          if (skuInfo) {
            day.bottomInfo = `￥${skuInfo.sellPrice}`
          }
        }
        return day
      }

      handleBuyClick = () => {
        if (this.jointGoodsModel.value.isDateStock) {
          submit(async $ => {
            $.start()
            const skuDetail = await apiCommodityWriteOffCommoditySkuDetail({
              commodityId: this.jointGoodsModel.value.goodsId,
            }).then(requiredDeep)
            this.skuData.value = keyBy(skuDetail, item =>
              formatDate(anyToDate(item.stockDate), 'yyyy-mm-dd'),
            )
            this.initialDate.value = anyToDate(
              orderBy(
                skuDetail,
                item => anyToDate(item.stockDate).getTime(),
                'asc',
              ).find(
                item =>
                  isToday(anyToDate(item.stockDate)) ||
                  isFuture(anyToDate(item.stockDate)),
              )!.stockDate,
            )
            this.showDatePicker.value = true
          })
        } else {
          this.handleDateConfirm()
        }
      }

      handleDateConfirm = (date?: Date) => {
        Track.pushEvent({
          type: 'click',
          name: '立即购买',
          id: 'JiaGou',
          extra: {
            commodity_id: this.jointGoodsModel.value.commodityId,
            commodity_name: this.jointGoodsModel.value.commodityTitle,
            commodity_tag: '',
            original_price: this.jointGoodsModel.value.dashPrice,
            present_price: this.jointGoodsModel.value.lowestPrice,
            discount_price:
              this.jointGoodsModel.value.dashPrice -
              this.jointGoodsModel.value.lowestPrice,
            store_id: this.jointGoodsModel.value.merchantId,
            store_name: this.jointGoodsModel.value.merchantName,
            sku_id: this.jointGoodsModel.value.goodsId,
            sku_name: '',
            additional_purchase_type: '立即购买',
          },
        })
        submit(async $ => {
          $.start()
          const preOrderRequestData: ApiTradeGeneralTradePreOrderRequest = {
            preOrderType: 2 as any,
            skuInfo: [
              {
                commodityId: this.jointGoodsModel.value.goodsId,
                count: 1,
                sellChannelId: currentSaleChannelId,
                skuId: this.jointGoodsModel.value.goodsId,
                stockDate: date ? formatDate(date, 'yyyy-mm-dd') : undefined,
              },
            ],
          }
          await apiTradeGeneralTradePreOrder(preOrderRequestData)
          this.showDatePicker.value = false
          nextTick(() => {
            navigateTo('JointOrderPlace', {
              preOrderRequestData: JSON.stringify(preOrderRequestData),
            })
          })
        })
      }
    },
)
